import { NAVBAR_HEIGHT } from '@/layout';
import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface MessageSearchDrawerHeaderProps {
  onClose: () => void;
}

export function MessageSearchDrawerHeader({ onClose }: MessageSearchDrawerHeaderProps) {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Box
      sx={{
        display: 'flex',
        height: NAVBAR_HEIGHT,
        alignItems: 'center',
        borderColor: 'divider',
        justifyContent: 'space-between',
        px: 2
      }}
    >
      <Typography variant='h6' noWrap color='text.primary'>
        {t('conversations.search.title', 'Search Messages')}
      </Typography>
      <IconButton onClick={handleClose} size='small' aria-label={t('common.close', 'Close')}>
        <Close />
      </IconButton>
    </Box>
  );
}
